import React from "react";
import ProgressBar from "../ProgressBar/ProgressBar";
import { cn } from "../../Utils/helper";
import { Helmet } from "react-helmet-async";
import images from "../../images";

const Header = ({
  title,
  className,
  backIcon,
  onBackClick,
  menuIcon,
  onMenuClick,
  btnEdit,
  handleEdit,
  classNameBtnEdit,
  iconRespon,
  currentStep,
  totalSteps,
  textRespon,
  classNameMenuIcon,
  subTitle,
  subTitleIcon,
  onSubTitleClick,
  backIconSubtitle,
  handleBackIconSubtitle,
  isDropDownOpen,
  onDropDownDiscardClick,
  onDropDownEndClick,
  textDiscard,
  textEnd,
  onDropDownCotinueClick,
  textContinue,
}) => {
  return (
    <div
      className={cn(
        "flex flex-col w-full bg-[#3F54DF] rounded-none min-h-[60px] rounded-bl-xl rounded-br-xl relative",
        className
      )}
    >
      <Helmet>
        <meta name="theme-color" content="#3F54DF" />
      </Helmet>

      {isDropDownOpen && (
        <div
          className="fixed inset-0 bg-black bg-opacity-50 z-10"
          onClick={() => {
            if (typeof onSubTitleClick === "function") {
              onSubTitleClick();
            }
          }}
        />
      )}

      {subTitle && (
        <>
          {backIconSubtitle && (
            <div className="px-4" onClick={handleBackIconSubtitle}>
              <img src={backIconSubtitle} alt="Back" className="max-w-[32px]" />
            </div>
          )}

          <div className="flex flex-row justify-between px-4 items-center">
            <div className="gap-1 self-stretch my-auto text-2xl font-bold leading-relaxed text-white whitespace-nowrap">
              {subTitle}
            </div>
            {subTitleIcon ? (
              <div className="relative z-20">
                <div
                  onClick={() =>
                    typeof onSubTitleClick === "function" && onSubTitleClick()
                  }
                >
                  <img
                    loading="lazy"
                    src={subTitleIcon}
                    alt="Menu"
                    className="object-contain shrink-0 self-stretch my-auto aspect-square w-[32px]"
                  />
                </div>
                {isDropDownOpen && (
                  <div className="flex flex-col absolute right-0 top-[35px] z-20 gap-2.5 bg-white rounded-[10px] py-1 w-[130px] shadow-[0_2px_6px_-2px_rgba(0,0,0,0.08)] border-[#EEEAE8] border-solid border-[1px]">
                    {onDropDownEndClick && (
                      <div
                        onClick={() =>
                          typeof onDropDownEndClick === "function" &&
                          onDropDownEndClick()
                        }
                        className="flex flex-row cursor-pointer items-center gap-2 hover:bg-[#FCF8E6] px-2 py-1.5 rounded-sm w-full"
                      >
                        <img
                          src={images.SaveDraftIcon}
                          alt="End Task"
                          className="w-4 h-4"
                        />
                        <span className="text-sm">{textEnd || "End Task"}</span>
                      </div>
                    )}
                    <div
                      onClick={() =>
                        typeof onDropDownDiscardClick === "function" &&
                        onDropDownDiscardClick()
                      }
                      className="flex flex-row cursor-pointer items-center gap-2 hover:bg-[#FCF8E6] px-2 py-1.5 rounded-sm w-full"
                    >
                      <img
                        src={images.DiscardIcon}
                        alt="Discard"
                        className="w-4 h-4"
                      />
                      <span className="text-sm">{textDiscard}</span>
                    </div>

                    {textContinue && (
                      <div
                        onClick={() =>
                          typeof onDropDownCotinueClick === "function" &&
                          onDropDownCotinueClick()
                        }
                        className="flex flex-row cursor-pointer items-center gap-2 hover:bg-[#FCF8E6] px-2 py-1.5 rounded-sm w-full"
                      >
                        <img
                          src={images.ContinueIcon}
                          alt="Discard"
                          className="w-4 h-4"
                        />
                        <span className="text-sm">{textContinue}</span>
                      </div>
                    )}
                  </div>
                )}
              </div>
            ) : (
              <div className="flex overflow-hidden gap-0.5 justify-center items-center self-stretch px-1.5 my-auto rounded-xl min-h-[46px] w-[46px]"></div>
            )}
          </div>
        </>
      )}

      {title && (
        <div className="flex flex-1 gap-10 justify-between items-center px-4 py-2.5 size-full cursor-pointer">
          {backIcon ? (
            <div
              onClick={() => typeof onBackClick === "function" && onBackClick()}
            >
              <img
                loading="lazy"
                src={backIcon}
                alt="Back"
                className="object-contain shrink-0 self-stretch my-auto aspect-square w-[42px]"
              />
            </div>
          ) : (
            <div className="flex overflow-hidden gap-0.5 justify-center items-center self-stretch px-1.5 my-auto rounded-xl min-h-[46px] w-[46px]"></div>
          )}

          <div className="gap-1 self-stretch my-auto text-lg font-semibold leading-relaxed text-white whitespace-nowrap">
            {title}
          </div>

          {menuIcon ? (
            <div
              onClick={() => typeof onMenuClick === "function" && onMenuClick()}
              className={cn(
                `flex overflow-hidden gap-0.5 justify-center items-center self-stretch px-1.5 my-auto rounded-xl min-h-[46px] w-[46px] ${classNameMenuIcon}`
              )}
            >
              <img
                loading="lazy"
                src={menuIcon}
                alt="Menu"
                className="object-contain self-stretch my-auto w-9 rounded-md aspect-square"
              />
            </div>
          ) : btnEdit ? (
            <button className={classNameBtnEdit} onClick={handleEdit}>
              {btnEdit}
            </button>
          ) : (
            <div className="flex overflow-hidden gap-0.5 justify-center items-center self-stretch px-1.5 my-auto rounded-xl min-h-[46px] w-[46px]"></div>
          )}
        </div>
      )}

      {textRespon && (
        <div className="p-3">
          <section className="flex flex-col justify-center p-3 w-full bg-white rounded-2xl">
            <header className="flex gap-2.5 items-center self-center text-lg font-semibold text-zinc-800">
              <img
                src={iconRespon}
                alt="Response Icon"
                className="object-contain shrink-0 self-stretch my-auto w-6 aspect-square"
              />
              <h2 className="self-stretch my-auto">{textRespon}</h2>
            </header>

            {currentStep && totalSteps && (
              <ProgressBar currentStep={currentStep} totalSteps={totalSteps} />
            )}
          </section>
        </div>
      )}
    </div>
  );
};

export default Header;
